import React, { useContext, useEffect, useRef, useState } from 'react';
import Application from '../../../StateContext/Application';
import { Cancel32, DeleteRed32, EditBlueBlue32, submit } from '../../../../../public/LoginImages/importimages';

const PurchaseList = () => {
  const statecalls = useContext(Application);
  const { GetVendors, PurchaseList } = statecalls;

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 6;
  const totalPages = Math.ceil(data.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = data.slice(indexOfFirstBill, indexOfLastBill);
  const formdataRef = useRef(null)

  const [vendor, setVendor] = useState([])
  const [formData, setFormData] = useState({
    vendorName: '',
    poNumber: '',
    poDate: '',
    productName: '',
    quantity: '',
    uom: '',
    remark: '',
  });
  const [editId, setEditId] = useState(null);

  const getAllData = async () => {
    const response = await PurchaseList("get");
    if (response && Array.isArray(response)) {
      setData(response);
      console.log("Set data:", response);
    } else {
      setData([]);
    }
  };
  const getVendors = async () => {
    let data = await GetVendors()
    console.log("Fetched Vendors:", data);
    setVendor(data)
  }

  useEffect(() => {
    getVendors();
    getAllData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const Submit = async (e) => {
    e.preventDefault();
    console.log("Form submitted123", formData);

    if (editId) {
      const response = await PurchaseList("update", { ID: editId, ...formData });
      console.log("Update response:", response);
      if (response?.message === "success") {
        alert("Product updated successfully");
        getAllData();
        setFormData({
          vendorName: '',
          poNumber: '',
          poDate: '',
          productName: '',
          quantity: '',
          uom: '',
          remark: '',
        });
        setEditId(null);
      }
    } else {
      const response = await PurchaseList("insert", formData);
      console.log("Insert response:", response);
      if (response?.message === "success") {
        alert("added successfully")
        getAllData();
        setFormData({
          vendorName: '',
          poNumber: '',
          poDate: '',
          productName: '',
          quantity: '',
          uom: '',
          remark: '',
        });
      }
    }
  };

  const handleEdit = (item) => {
    setFormData({
      vendorName: item.vendorName,
      poNumber: item.poNumber,
      poDate: item.poDate,
      productName: item.productName,
      quantity: item.quantity,
      uom: item.uom,
      remark: item.remark,
    });
    setEditId(item.ID);
    console.log("edit id", item.ID);
  };
  const handleDelete = async (e, ID) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete?")) {
      const response = await PurchaseList("delete", { ID });
      if (response?.message === "success") {
        getAllData();
      }
    }
  };
  const resetdata = () => {
    formdataRef.current.reset()
    setFormData({
      vendorName: '',
      poNumber: '',
      poDate: '',
      productName: '',
      quantity: '',
      uom: '',
      remark: '',
    });
    setEditId(null);
  }
  return (
    <div style={{ display: 'grid', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f4f7fe', overflowY: 'auto', maxHeight: '91vh', padding: '0px 0px 20px 0px' }}>
      <div style={{ backgroundColor: '#f4f7fe', backgroundSize: 'cover', width: '81vw', alignSelf: 'center', display: 'grid', justifyContent: "center", padding: '1rem', position: "relative", backdropFilter: 'blur(10px)', overflowY: 'auto' }}>

        <div style={{ display: "grid", justifyContent: "center" }}>
          <div className="card-body my-3" style={{ width: "75vw" }}>
            <form onSubmit={Submit} ref={formdataRef} style={{ backgroundColor: 'rgb(255,255,255,0.8)', borderRadius: '20px' }}>

              <div style={{ display: 'grid', justifyContent: 'center', padding: '2rem' }}>
                <h5 className='mx-3' style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', padding: '10px' }}>{editId ? "Edit Product" : "Add new purchase"}</h5>
                <div style={{ backgroundColor: '#f4f7fe', borderRadius: '20px', paddingBottom: '15px' }}>
                  <div style={{ display: 'flex' }}>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label className='form-label'>Select Vendor</label>
                      <select style={{ boxShadow: '0px 0px 4px' }} class="form-select" aria-label="Default select example" name="vendorName" value={formData.Vendor_Company_Name} onChange={handleChange} aria-required>
                        <option selected disabled >Select Vendor</option>
                        {vendor && vendor.map((e) => (
                          <option className="form-control " name="Vendor_Company_Name" value={e.Bidder_CompanyName} id={e.Bidder_CompanyName}>{e.Bidder_CompanyName}</option>
                        ))}
                      </select>
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label className='form-label'>PO Number</label>
                      <input type='number' className='form-control' placeholder='Enter purchase order list here' name="poNumber" value={formData.poNumber} onChange={handleChange} required/>
                    </div>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label className='form-label'>PO Date</label>
                      <input type='date'className="form-control custom-date-input"placeholder='Enter purchase order Date here' name="poDate" value={formData.poDate} onChange={handleChange} required/>
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label className='form-label'>Product Name</label>
                      <input type='text' className='form-control' placeholder='Enter product name here' name="productName" value={formData.productName} onChange={handleChange} required/>
                    </div>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label className='form-label'>Quantity</label>
                      <input type='text' className='form-control' placeholder='Enter quality here' name="quantity" value={formData.quantity} onChange={handleChange} required/>
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label className='form-label'>UOM</label>
                      <select name="uom" value={formData.uom} onChange={handleChange} className="form-select" style={{ boxShadow: '0px 0px 4px' }}>
                        <option value="">Select UOM</option>
                        <option value="Kg">Kgs</option>
                        <option value="Ton">Bdle</option>
                        <option value="Litre">Ltr</option>
                        <option value="Piece">Nos</option>
                        <option value="Meter">Set</option>
                        <option value="Pack">Roll</option>
                        <option value="Pkt">Pkt</option>
                        <option value="Kit">Kit</option>
                      </select>
                    </div>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label className='form-label'>Remark</label>
                      <input type='text' className='form-control' placeholder='Enter Remark here' name="remark" value={formData.remark} onChange={handleChange} required/>
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}></div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', paddingTop: '10px' }}>
                    {editId ? (
                      <>
                        <button type="submit" style={{ backgroundColor: '#28a745', width: '6rem', height: '2rem', color: 'white', border: 'none', borderRadius: '5px', }}> Update</button>
                        <button type="button" onClick={resetdata} style={{ backgroundColor: '#6c757d', width: '6rem', height: '2rem', color: 'white', border: 'none', borderRadius: '5px', }}> Cancel</button>
                      </>
                    ) : (
                      <>
                        <button type="submit" style={{
                          display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '20px', width: '7rem', height: '2.5rem', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', border: 'none', fontSize: '17px',
                          gap: '4px', color: 'white',
                        }}><img src={submit} style={{ width: '1.2rem', paddingBottom: '3px' }} /> Submit</button>
                        <button type="button" onClick={resetdata} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '20px', width: '7rem', height: '2.5rem', backgroundColor: '#E63E23', border: 'none', fontSize: '17px', gap: '4px', color: 'white', }}>
                          <img src={Cancel32} style={{ width: '1.2rem', paddingBottom: '3px' }} /> Clear</button>
                      </>
                    )}
                  </div>

                </div>

              </div>
            </form>
            <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px" }}>
              <div style={{ display: 'grid', justifyContent: 'center', width: '75vw', borderRadius: '20px', backgroundColor: 'white', padding: '2rem', }}>
                <h5 style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', }}>Add Product List</h5>
                <div style={{ display: 'flex', justifyContent: 'center', width: '70vw', backgroundColor: '#e8f7f3', border: '1px solid darkgray' }}>
                  <table style={{ backgroundColor: '#e8f7f3', width: '100%' }}>
                    <thead>
                      <tr style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', height: '2.5rem' }}>
                        <th>Sr.No</th>
                        <th>vendor Name</th>
                        <th>poNumber</th>
                        <th>poDate</th>
                        <th>Product Name</th>
                        <th>quantity</th>
                        <th>UOM</th>
                        <th>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item, index) => (
                        <tr key={item.ID || index}>
                          <td>{index + 1}</td>
                          <td>{item.vendorName}</td>
                          <td>{item.poNumber}</td>
                          <td>{item.poDate}</td>
                          <td>{item.productName}</td>
                          <td>{item.quantity}</td>
                          <td>{item.uom}</td>
                          <td>{item.remark}</td>
                          <td style={{ padding: '5px' }}>
                            <button onClick={() => handleEdit(item)} className="btn btn-custom-edit" style={{ width: '5rem', border: '1px solid #502eff', backgroundColor: 'white', borderRadius: '5px', padding: '5px', fontSize: '14px', color: '#502eff', fontWeight: '700' }}><img className="icon-edit" src={EditBlueBlue32} style={{ width: '1.3rem' }} /> Edit</button>
                            <button onClick={(e) => handleDelete(e, item.ID)} className="btn btn-custom-delete" style={{ width: '6rem', border: '1px solid #ee5d50', backgroundColor: 'white', borderRadius: '5px', padding: '5px', marginLeft: '10px', color: '#ee5d50', fontSize: '14px', fontWeight: '700' }}><img className="icon-delete"
                              src={DeleteRed32}
                              style={{ width: '1.3rem', paddingBottom: '0.2rem' }}
                            /> Delete</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 3rem', height: '3rem', alignItems: 'center' }}>
              <div>
                <p style={{ margin: '0px', color: 'black' }}>
                  Showing {indexOfFirstBill + 1} to {Math.min(indexOfLastBill, data.length)} of {data.length} entries
                </p>

              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {/* First Page Button */}
                <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                  style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                  &laquo;
                </button>
                {/* Previous Button */}
                <button
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                  &lt;
                </button>

                <button
                  style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                </button>
                {/* Next Button */}
                <button
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                  &gt;
                </button>
                {/* Last Page Button */}
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  disabled={currentPage === totalPages}
                  style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                  &raquo;
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseList;
